import { useTranslation } from "react-i18next";
import SectionHeader from "../../../util/component/SectionHeader";
import { Route, Routes } from "react-router-dom";
import React from "react";
import Clusters from "./cluster/sections/Clusters";
import ClusterWizard from "./cluster/pages/ClusterWizard";
import ClusterPreview from "./cluster/sections/ClusterPreview";

const PageCluster = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'clusters' });

    return (
        <Routes>
            <Route path="/" element={
                <>
                    <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                    <Clusters/>
                </>
            }/>
            <Route path="/:id/*" element={
                <>
                    <SectionHeader title={t('header.title')} subtitle={t('header.subtitle')}/>
                    <ClusterPreview />
                </>
            }/>
            <Route path="/wizard" element={
                <>
                    <SectionHeader title={t('cluster-wizard.header.title')} subtitle={t('cluster-wizard.header.subtitle')}/>
                    <ClusterWizard/>
                </>
            }/>
        </Routes>
    );
}

export default PageCluster;